module.exports = __webpack_public_path__ + "img/aboutUsImg02.44f00572.png";